<template>
  <!-- content -->
  <div class="content--block">
    <div class="custom-content--header-min">
      <div class="custom-content--header-min-container">
        <h1 class="custom-content--header-min-heading">API explorer</h1>
      </div>
    </div>
    <div class="custom-content--50-50-list-name">
      <div class="custom-content--heading">
        <h2>Account list</h2>
      </div>
      <div id="loadingDiv" class="custom-content--header-min api-content">
        <div class="wait">
          <div class="wait--preloader">
            <svg
              xmlns:svg="http://www.w3.org/2000/svg"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.0"
              width="64px"
              height="64px"
              viewBox="0 0 128 128"
              xml:space="preserve"
              class
            >
              <g transform="rotate(276.875 64 64)">
                <path
                  d="M0.00765413755,65 C0.00255755226,64.6672764 0,64.3339369 0,64 C0,28.653776 28.653776,0 64,0 C99.346224,0 128,28.653776 128,64 C128,99.346224 99.346224,128 64,128 L64,118 C93.8233765,118 118,93.8233765 118,64 C118,34.1766235 93.8233765,10 64,10 C34.1766235,10 10,34.1766235 10,64 C10,64.3340505 10.0030332,64.6673925 10.0090737,65 L0.00765413755,65 Z"
                  fill-opacity="1"
                ></path>
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="0 64 64"
                  to="360 64 64"
                  dur="1800ms"
                  repeatCount="indefinite"
                ></animateTransform>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- swagger -->
    <div id="loadedDiv" style="display:none" class="custom-content--header-min">
      <div class="download-link">
        <a target="_blank" href="/docs/Account-List.json">Download Json file</a>
      </div>
      <div id="swagger-ui" class="api-content"></div>
    </div>
    <!--/. swagger -->
  </div>
  <!--/. content -->
</template>
<script>
export default {
  name: "api-account-list",
  mounted: function() {
    setTimeout(this.initSwagger, 1200);
  },
  methods: {
    initSwagger: function() {
      const ui = SwaggerUIBundle({
        url: "/docs/Account-List.json",
        dom_id: "#swagger-ui",
        deepLinking: true,
        presets: [SwaggerUIBundle.presets.apis, SwaggerUIStandalonePreset],
        plugins: [SwaggerUIBundle.plugins.DownloadUrl],
        layout: "StandaloneLayout",
        responseInterceptor: function(a) {
          $("#loadingDiv").hide();
          $("#loadedDiv").show();
        }
      });
      window.ui = ui;
    }
  }
};
</script>
<style>
.wait {
  margin: 24px 0;
}
.wait--preloader {
  margin: 0 auto;
  width: 40px;
  height: 40px;
}
.wait--preloader svg {
  fill: #0a3443;
  width: 40px;
  height: 40px;
}
</style>